// extracted by mini-css-extract-plugin
module.exports = {"column":"styles_column__WWgAF","city":"styles_city__bwo6f","text":"styles_text__GR0vp"};